export const ACTIVE_GIFTS_PAGE = '/gifts';
export const REALIZED_GIFTS_PAGE = '/realized-gifts';
export const REQUISITES_GIFTS_PAGE = '/requisites';
